import { useQuery } from '@tanstack/react-query';
import { DIAM_API_PATH, diamQueryKeys, getTeamById } from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';

export function useTeam(teamId: string | undefined) {
  const { getIdToken, apiUrl, isSignedIn } = useApiEssentials(DIAM_API_PATH);

  return useQuery({
    queryKey: diamQueryKeys.team(teamId ?? ''),
    queryFn: async () => {
      if (!teamId) {
        throw new Error('A team id is required');
      }

      const idToken = await getIdToken();
      return getTeamById(apiUrl, idToken, teamId);
    },
    enabled: isSignedIn && Boolean(teamId),
    retry: false,
    refetchOnWindowFocus: false,
  });
}
